<template>
  <div id="formulario" class="cta-wrap">
    <div class="cta-left">
      <h2 class="cta-title">Ficou interessado?</h2>
      <p class="cta-subtitle">
        Próximo passo para ganhar controle. Preencha com seus dados que, em breve, entraremos em contato
        com você:
      </p>
    </div>

    <div class="cta-right">
      <form class="lead-form" @submit.prevent="handleSubmit">
        <!-- Campos fixos do funil (enviados junto com o formulário) -->
        <input type="hidden" name="sistema_id" v-model.number="form.sistema_id" />
        <input type="hidden" name="campanha_id" v-model.number="form.campanha_id" />

        <div class="lead-grid">
          <div class="field">
            <label for="leadNome">
              * Nome completo
            </label>
            <input id="leadNome" v-model.trim="form.nome" type="text" placeholder="Seu nome completo" required @focus="handleFormStart" />
          </div>

          <div class="field">
            <label for="leadEmail">
              * E-mail
            </label>
            <input id="leadEmail" v-model.trim="form.email" type="email" placeholder="seu@email.com" required />
          </div>

          <div class="field">
            <label for="leadWhatsapp">
              WhatsApp
            </label>
            <input id="leadWhatsapp" v-model.trim="form.whatsapp" type="tel" placeholder="(87) 9 9999-9999" />
          </div>

          <div class="field">
            <label for="leadUf">
              * Estado (UF)
            </label>
            <select
              id="leadUf"
              v-model="form.uf"
              required
              :disabled="isLoadingEstados"
              @change="onEstadoChange"
            >
              <option value="" disabled>
                {{ isLoadingEstados ? 'Carregando estados...' : 'Selecione o estado' }}
              </option>
              <option v-for="estado in estados" :key="estado.id" :value="estado.id">
                {{ estado.nome }} ({{ estado.sigla }})
              </option>
            </select>
          </div>

          <div class="field">
            <label for="leadCidade">
              * Cidade
            </label>
            <select
              id="leadCidade"
              v-model="form.cidade"
              required
              :disabled="!form.uf || isLoadingCidades"
            >
              <option value="" disabled>
                {{ !form.uf ? 'Selecione um estado' : isLoadingCidades ? 'Carregando cidades...' : 'Selecione a cidade' }}
              </option>
              <option v-for="cidade in cidades" :key="cidade.id" :value="cidade.id">
                {{ cidade.nome }}
              </option>
            </select>
          </div>

          <div class="field">
            <label for="leadEmpresa">
              * Nome da Empresa
            </label>
            <input
              id="leadEmpresa"
              v-model.trim="form.empresa"
              type="text"
              placeholder="Nome da sua empresa"
              required
            />
          </div>
        </div>

        <div class="field field-cta">
          <button class="btn btn-primary" type="submit" :disabled="isSubmitting">
            {{ isSubmitting ? 'Enviando...' : 'Solicitar Contato' }}
          </button>

          <a class="btn btn-secondary client-login" :href="appLoginUrl">
            Já sou cliente
          </a>
        </div>

        <p class="privacy-note privacy-note-link">
          Consulte nossa
          <router-link to="/politica-privacidade">Política de Privacidade</router-link>
          para saber como tratamos seus dados no App Profissionais Android.
        </p>

        <div v-if="submitSuccess" class="submit-success" role="status">
          Solicitação enviada com sucesso! Em breve um especialista entrará em contato.
        </div>

        <div v-if="submitError" class="submit-error" role="alert">
          {{ submitError }}
        </div>

        <p class="privacy-note">
          Ao preencher, você concorda em receber contato do nosso especialista.
        </p>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CTASection',
  props: {
    appLoginUrl: { type: String, required: true },
    whatsAppUrl: { type: String, default: '' }
  },
  data() {
    return {
      isSubmitting: false,
      submitError: '',
      submitSuccess: false,
      formStarted: false,
      estados: [],
      cidades: [],
      isLoadingEstados: false,
      isLoadingCidades: false,
      form: {
        nome: '',
        email: '',
        whatsapp: '',
        sistema_id: 202414,
        uf: '',
        cidade: '',
        empresa: '',
        campanha_id: 21
      }
    }
  },
  methods: {
    async loadEstados() {
      this.isLoadingEstados = true
      try {
        const baseUrl = 'https://servicodados.ibge.gov.br/api/v1/localidades/estados'
        const res = await fetch(`${baseUrl}?orderBy=nome`)
        if (!res.ok) throw new Error('Falha ao carregar estados (IBGE).')

        const data = await res.json()
        this.estados = (data || []).map((estado) => ({
          id: estado.id,
          nome: estado.nome,
          sigla: estado.sigla
        }))
      } catch (err) {
        this.submitError = (err && err.message) ? err.message : 'Não foi possível carregar os estados.'
      } finally {
        this.isLoadingEstados = false
      }
    },
    async onEstadoChange() {
      this.form.cidade = ''
      this.cidades = []
      if (!this.form.uf) return

      this.isLoadingCidades = true
      try {
        const baseUrl = 'https://servicodados.ibge.gov.br/api/v1/localidades/estados'
        const res = await fetch(`${baseUrl}/${this.form.uf}/municipios`)
        if (!res.ok) throw new Error('Falha ao carregar cidades (IBGE).')

        const data = await res.json()
        this.cidades = (data || []).map((cidade) => ({
          id: cidade.id,
          nome: cidade.nome
        }))
      } catch (err) {
        this.submitError = (err && err.message) ? err.message : 'Não foi possível carregar as cidades.'
      } finally {
        this.isLoadingCidades = false
      }
    },
    handleFormStart() {
      if (!this.formStarted) {
        this.formStarted = true
        this.$posthog.capture('lead_form_started')
      }
    },
    async handleSubmit() {
      this.isSubmitting = true
      this.submitError = ''
      this.submitSuccess = false

      if (!this.form.nome) {
        this.submitError = 'Por favor, preencha o campo Nome completo.'
        this.isSubmitting = false
        return
      }
      if (!this.form.email) {
        this.submitError = 'Por favor, preencha o campo E-mail.'
        this.isSubmitting = false
        return
      }
      if (!this.form.uf) {
        this.submitError = 'Por favor, selecione o Estado (UF).'
        this.isSubmitting = false
        return
      }
      if (!this.form.cidade) {
        this.submitError = 'Por favor, selecione a Cidade.'
        this.isSubmitting = false
        return
      }
      if (!this.form.empresa) {
        this.submitError = 'Por favor, preencha o campo Nome da Empresa.'
        this.isSubmitting = false
        return
      }

      const payload = {
        nome: this.form.nome.trim(),
        email: this.form.email.trim(),
        telefone: this.form.whatsapp || '',
        cidade: this.form.cidade,
        empresa: this.form.empresa.trim(),
        uf: this.form.uf,
        sistema_id: this.form.sistema_id,
        campanha_id: this.form.campanha_id,
        parceiro_id: 1
      }

      try {
        const res = await fetch('https://app.sidsolucoes.com/api/interessado/gravar', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        })

        if (!res.ok) {
          const text = await res.text().catch(() => '')
          throw new Error(text || 'Erro ao enviar formulário.')
        }

        this.submitSuccess = true
        this.$posthog.capture('lead_form_submitted', {
          has_whatsapp: !!this.form.whatsapp,
          state_id: this.form.uf,
          campanha_id: this.form.campanha_id
        })
      } catch (err) {
        this.submitError = (err && err.message) ? err.message : 'Ocorreu um erro ao enviar seus dados. Tente novamente.'
        this.$posthog.capture('lead_form_failed', {
          error: err && err.message ? err.message : 'unknown'
        })
        this.$posthog.captureException(err)
      } finally {
        this.isSubmitting = false
      }
    }
  },
  mounted() {
    this.loadEstados()
  }
}
</script>

<style scoped>
.cta-wrap {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  align-items: start;
  background: #fff;
  border: 1px solid rgba(77, 186, 135, 0.35);
  border-radius: 22px;
  padding: 26px 24px 22px;
}

.cta-label {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  border-radius: 999px;
  background: rgba(77, 186, 135, 0.10);
  border: 1px solid rgba(77, 186, 135, 0.45);
  font-weight: 950;
  color: #0b1220;
}

.cta-title {
  margin: 12px 0 10px;
  font-size: 42px;
  line-height: 1.1;
  letter-spacing: -0.03em;
}

.cta-subtitle {
  margin: 0;
  color: rgba(100, 116, 139, 0.95);
  line-height: 1.65;
  font-size: 16px;
}

.lead-form {
  display: grid;
  gap: 12px;
}

.lead-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
}

.field {
  min-width: 0;
}

.field select {
  width: 100%;
  padding: 12px 14px;
  border-radius: 14px;
  border: 1px solid rgba(148, 163, 184, 0.45);
  outline: none;
  font-size: 14px;
  background: #fff;
}

.field select:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.field input,
.field select {
  background: #fff;
}

.field input:focus,
.field select:focus {
  border-color: rgba(77, 186, 135, 0.55);
  box-shadow: 0 0 0 4px rgba(77, 186, 135, 0.12);
}

.field-span-2 {
  grid-column: 1 / -1;
}

.field label {
  display: block;
  font-weight: 900;
  font-size: 13px;
  margin-bottom: 6px;
  color: #0f172a;
}

.field input {
  width: 100%;
  padding: 12px 14px;
  border-radius: 14px;
  border: 1px solid rgba(148, 163, 184, 0.45);
  outline: none;
  font-size: 14px;
  background: #fff;
}

.field input:focus {
  border-color: rgba(77, 186, 135, 0.55);
  box-shadow: 0 0 0 4px rgba(77, 186, 135, 0.12);
}

.field-cta {
  margin-top: 4px;
  grid-column: 1 / -1;
  display: flex;
  justify-content: flex-start;
  gap: 12px;
  flex-wrap: wrap;
}

.lead-actions {
  display: grid;
  gap: 10px;
  align-content: start;
}

.help {
  color: var(--easy-muted);
  font-weight: 700;
  font-size: 13px;
}

.submit-error {
  margin-top: 8px;
  padding: 10px 12px;
  border-radius: 12px;
  border: 1px solid rgba(239, 68, 68, 0.35);
  background: rgba(239, 68, 68, 0.08);
  color: rgba(239, 68, 68, 0.95);
  font-weight: 800;
  font-size: 13px;
}

.submit-success {
  margin-top: 8px;
  padding: 10px 12px;
  border-radius: 12px;
  border: 1px solid rgba(77, 186, 135, 0.35);
  background: rgba(77, 186, 135, 0.10);
  color: rgba(17, 94, 62, 0.95);
  font-weight: 800;
  font-size: 13px;
}

.privacy-note {
  margin: 0;
  color: rgba(100, 116, 139, 0.95);
  font-weight: 800;
  font-size: 13px;
  line-height: 1.5;
}

.privacy-note-link {
  margin-top: 4px;
}

.privacy-note-link a {
  color: var(--easy-dark);
  text-decoration: none;
  border-bottom: 1px dashed rgba(77, 186, 135, 0.7);
}

@media (max-width: 980px) {
  .cta-wrap {
    grid-template-columns: 1fr;
  }

  .lead-grid {
    grid-template-columns: 1fr;
  }

  .field-cta {
    grid-column: auto;
  }
}
</style>
